import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';

// Images
import search from '../../assets/ic_search.png';
import { useDebounce } from '../../utils/useDebounce';

const SearchBox = ({ onChange, placeholder = 'Search Playlist Here...' }) => {
  const [searchInput, setSearchInput] = useState('');
  const debouncedValue = useDebounce(searchInput, 300);

  useEffect(() => {
    onChange(debouncedValue);
  }, [debouncedValue]);

  return (
    <Grid item className="search_row">
      <input
        className="input_field"
        placeholder={placeholder}
        type="text"
        value={searchInput}
        onChange={(e) => setSearchInput(e.target.value)}
      />
      <img alt="search" width={21} height={21} src={search} />
    </Grid>
  );
};

export default SearchBox;

